import { Flex } from 'components/Flex';
import styled from 'styled-components';
import { BKJButton } from '@bookjane2/bookjane-design-library';

export const ReleaseShiftViewWrapper = styled(Flex)`
  padding: 32px;
  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    padding: 32px 20px;
  }
`;

export const ReleaseShiftTitle = styled.h3`
  ${({ theme }) => theme.typography.H3};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin-bottom: 32px;
  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    font-size: 18px;
  }
`;

export const FormLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  ${({ theme }) => theme.common.Ellipsis};
  line-height: 21px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin-bottom: 8px;
  display: block;
`;

export const WarningText = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  line-height: 21px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};

  margin-left: 14px;
`;

export const FormGroup = styled.div`
  margin-bottom: 32px;
  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    margin-bottom: 24px;
  }
`;
export const InnerWrapper = styled.div``;
export const ReleaseContent = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  line-height: 21px;
  font-size: 16px;
  margin-bottom: 8px;
  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    font-size: 14px;
  }
`;

export const WarningWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.Grey1};
  padding: 16px;
  margin-bottom: 32px;
`;

export const ConfirmationButton = styled(BKJButton)`
  width: 180px;
  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    width: 100%;
    padding: 22px;
  }
`;

export const AddTimeOffSectionWrapper = styled.div`
  margin-top: 32px;
  padding-top: 32px;
  border-top: 1px solid ${({ theme }) => theme.colors.Grey2};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AddTimeOffTitle = styled.h4`
  ${({ theme }) => theme.typography.H4};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin: 0;
`;

export const AddTimeOffDescription = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  line-height: 21px;
  font-size: 16px;
  margin-bottom: 8px;
  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    font-size: 14px;
  }
`;

export const AddTimeOffCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AddTimeOffCheckboxLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 14px;
  line-height: 22px;
`;

export const AddTimeOffCustomFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const AddTimeOffCustomFieldsDivider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.Grey2};
  width: 100%;
  margin: 8px 0 16px 0;
`;

export const CustomFieldsTitle = styled.h4`
  ${({ theme }) => theme.typography.H4};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin: 8px 0 16px 0;
  font-size: 16px;
  font-weight: 600;
`;
